// extracted by mini-css-extract-plugin
export default {"chart":"xMUF4BeW30C1nKLcoEnQ"};